import { FC, useEffect, useRef } from "react";
import "../../../styles/components.css";
import { StandardHandler } from "../../../middleware/handlers/standard-handler";

interface LayersMenuProps {
  layersPanelReveal: boolean;
}

export const LayersMenu: FC<LayersMenuProps> = ({ layersPanelReveal }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    if (layersPanelReveal) {
      StandardHandler.MountLayersPanel(container);
    } else {
      StandardHandler.UnmountLayersPanel();
    }

    return () => {
      StandardHandler.UnmountLayersPanel();
    };
  }, [layersPanelReveal]);

  if (!layersPanelReveal) return null;

  return (
    <div id="layerMenu">
      <div id="layersWrapper" ref={containerRef} />
    </div>
  );
};

export default LayersMenu;
